import React, { Component } from 'react'
import { Loader } from 'semantic-ui-react'

import '../../../node_modules/semantic-ui-css/components/loader.css'

export default class LoaderElement extends Component {
  render () {
    return (
      <Loader active content='Loading' size='massive' />
    )
  }
}



// WEBPACK FOOTER //
// ./src/gallery/components/LoaderComponent.js